import { useTheme, useMediaQuery } from '@mui/material';
import { TheContent, TheFooter, TheHeader, TheMobileHeader } from '../';

const TheLayout = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  return (
    <>
      {isMobile ? <TheMobileHeader /> : <TheHeader />}
      <TheContent />
      <TheFooter />
    </>
  );
};

export default TheLayout;
